import { Text, TextType } from 'ui-components/components/text';

export const NameCell = ({ value }: { value: string }) => {
  return <Text textType={TextType.Paragraph} value={value} />;
};
